import React, { HTMLAttributes, useState } from 'react';
import { UnLoginIcon } from '../../components/icon';
import { FormattedMessage } from 'react-intl';
import { BeatLoading } from '../../components/layout/Loading';
import { WalletSelectorModal } from '../layout/WalletSelector';
import { useWalletSelector } from '../../context/WalletSelectorContext';
import { useClientMobile } from '../../utils/device';
import { BuyNearIcon, BuyNearHoverIcon } from '../icon/Nav';
import { openTransak } from '../alert/Transak';
import { getCurrentWallet } from '../../utils/wallets-integration';
import { WalletRiskCheckBoxModal } from 'src/context/modal-ui/components/WalletOptions/WalletRiskCheckBox';
import { CONST_ACKNOWLEDGE_WALLET_RISK } from 'src/constants/constLocalStorage';

export function BorderButton(
  props: HTMLAttributes<HTMLButtonElement> & { borderColor?: string } & {
    disabled?: boolean;
    rounded?: string;
    px?: string;
    py?: string;
    loading?: boolean;
  }
) {
  const {
    className,
    borderColor,
    disabled,
    rounded,
    px: paddingX,
    py: paddingY,
    loading,
    ...propsWithoutClassName
  } = props;
  return (
    <button
      disabled={disabled}
      className={`text-xs font-semibold border ${
        borderColor ? borderColor : 'border-greenColor'
      }  ${className} ${
        disabled ? 'bg-opacity-50 disabled:cursor-not-allowed' : ''
      } ${rounded || 'rounded-full'} ${paddingX || 'px-5'} ${
        paddingY || 'py-2.5'
      } ${loading ? 'opacity-40' : ''}`}
      {...propsWithoutClassName}
    >
      {props.children}
    </button>
  );
}

export function ConnectToNearBtn() {
  const [buttonLoading, setButtonLoading] = useState<boolean>(false);

  const [showWalletSelector, setShowWalletSelector] = useState(false);
  const [showWalletRisk, setShowWalletRisk] = useState<boolean>(false);
  const handleWalletModalOpen = () => {
    const isAcknowledgeWalletRisk = localStorage.getItem(
      CONST_ACKNOWLEDGE_WALLET_RISK
    );
    if (!isAcknowledgeWalletRisk) {
      setShowWalletRisk(true);
    } else {
      modal.show();
    }
  };
  const handleAcknowledgeClick = (status) => {
    if (status === true) {
      setShowWalletRisk(false);
      localStorage.setItem(CONST_ACKNOWLEDGE_WALLET_RISK, '1');
      modal.show();
    }
  };

  const { modal } = useWalletSelector();

  return (
    <>
      <div
        className={`flex items-center cursor-pointer justify-center rounded-full py-2 text-base ${
          buttonLoading ? 'opacity-40' : ''
        }`}
        style={{
          background: '#00DAFF',
          color: '#04121A',
        }}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          // setButtonLoading(true);
          //modal.show();
          handleWalletModalOpen();
        }}
      >
        {!buttonLoading && (
          <div className="mr-3.5">
            <UnLoginIcon />
          </div>
        )}

        <button disabled={buttonLoading}>
          <ButtonTextWrapper
            loading={buttonLoading}
            Text={() => (
              <FormattedMessage
                id="connect_to_near"
                defaultMessage="Connect to NEAR"
              />
            )}
          />
        </button>
      </div>

      <WalletRiskCheckBoxModal
        isOpen={showWalletRisk}
        setCheckedStatus={handleAcknowledgeClick}
        onClose={() => setShowWalletRisk(false)}
      />

      <WalletSelectorModal
        isOpen={showWalletSelector}
        onRequestClose={() => {
          window.location.reload();
          setShowWalletSelector(false);
        }}
        setShowWalletSelector={setShowWalletSelector}
      />
    </>
  );
}

export function ConnectToNearBtnGradient({
  className,
}: {
  className?: string;
}) {
  const [buttonLoading, setButtonLoading] = useState<boolean>(false);

  const { modal } = useWalletSelector();

  return (
    <>
      <div
        className={`${className} flex items-center cursor-pointer w-full justify-center rounded-full py-2 text-base bg-veGradient ${
          buttonLoading ? 'opacity-40' : ''
        }`}
        style={{
          color: '#fff',
        }}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          // setButtonLoading(true);
          modal.show();
        }}
      >
        {!buttonLoading && (
          <div className="mr-3.5">
            <UnLoginIcon />
          </div>
        )}

        <button>
          <ButtonTextWrapper
            loading={buttonLoading}
            Text={() => (
              <FormattedMessage
                id="connect_to_near_wallet"
                defaultMessage="Connect to NEAR Wallet"
              />
            )}
          />
        </button>
      </div>
    </>
  );
}

export function SolidButton(
  props: HTMLAttributes<HTMLButtonElement> & {
    disabled?: boolean;
    padding?: string;
    className?: string;
    loading?: boolean;
    disabledColor?: string;
  }
) {
  const {
    disabledColor,
    disabled,
    padding,
    className,
    onClick,
    loading,
    style,
  } = props;
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${disabled ? 'cursor-not-allowed opacity-40' : ''}  ${
        loading ? 'opacity-40' : ''
      }
        text-white rounded
        ${
          disabled && disabledColor
            ? disabledColor
            : ' bg-gradient-to-b from-gradientFrom to-gradientTo hover:from-gradientFromHover to:from-gradientToHover'
        }
       
         ${padding ? padding : 'py-2'}
        ${className ? className : ''}
      `}
      style={style}
    >
      {props.children}
    </button>
  );
}

export function SwapActionButton(
  props: HTMLAttributes<HTMLButtonElement> & {
    disabled?: boolean;
    loading?: boolean;
  }
) {
  const { disabled, className, onClick, loading, children } = props;
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled || loading}
      className={`flex flex-row w-full items-center justify-center px-5 py-3 rounded-full font-semibold bg-buttonGradientBg text-base gotham_bold ${
        disabled || loading ? 'cursor-not-allowed opacity-40' : ''
      } ${className || ''}`}
      style={{ color: '#04121A' }}
    >
      {children}
    </button>
  );
}

export function OutlineButton(
  props: HTMLAttributes<HTMLButtonElement> & {
    disabled?: boolean;
    padding?: string;
    className?: string;
  }
) {
  const { disabled, padding, className, onClick, style } = props;
  return (
    <button
      style={style}
      onClick={onClick}
      disabled={disabled}
      className={`flex items-center justify-center rounded ${
        disabled ? 'cursor-not-allowed  opacity-40' : ''
      } ${
        padding ? padding : 'py-2'
      } border border-gradientFromHover text-gradientFrom ${className}`}
    >
      {props.children}
    </button>
  );
}

export function GradientButton(
  props: HTMLAttributes<HTMLButtonElement> & {
    disabled?: boolean;
    padding?: string;
    className?: string;
    color?: string;
    btnClassName?: string;
    loading?: boolean;
    backgroundImage?: string;
    minWidth?: string;
    borderRadius?: string;
  }
) {
  const {
    loading,
    disabled,
    className,
    color,
    btnClassName,
    backgroundImage,
    minWidth,
    borderRadius,
    onClick,
  } = props;
  return (
    <div
      className={`${className ? className : ''} ${
        loading ? 'opacity-40' : ''
      } bg-gradient-to-b from-gradientFrom to-gradientTo hover:from-gradientFromHover to:from-gradientToHover`}
      style={{
        borderRadius: borderRadius || '999px',
        color: color || '#04121A',
        backgroundImage: backgroundImage || '',
        minWidth: minWidth || '',
      }}
    >
      <button
        onClick={onClick}
        disabled={disabled}
        className={`w-full h-full ${btnClassName ? btnClassName : ''}`}
      >
        {props.children}
      </button>
    </div>
  );
}
export function GreenLButton(
  props: HTMLAttributes<HTMLButtonElement> & {
    disabled?: boolean;
    loading?: boolean;
  }
) {
  const { disabled, loading, className, ...propsWithoutClassName } = props;
  return (
    <button
      disabled={disabled}
      style={{
        background: '#00DAFF',
        color: '#04121A',
      }}
      className={`w-full rounded-full text-base font-semibold border-0 px-5 py-3 focus:outline-none ${className} ${
        disabled ? 'opacity-40 cursor-not-allowed' : ''
      } ${loading ? 'opacity-40' : ''}`}
      {...propsWithoutClassName}
    >
      {props.children}
    </button>
  );
}

export function ButtonTextWrapper({
  Text,
  loading,
  loadingColor,
}: {
  Text: () => JSX.Element;
  loading: boolean;
  loadingColor?: string;
}) {
  return <>{loading ? <BeatLoading color={loadingColor} /> : <Text />}</>;
}

export function OperationButton(props: any) {
  const {
    loading,
    disabled,
    className,
    color,
    btnClassName,
    onClick,
    minWidth,
    background,
    borderRadius,
    ...reset
  } = props;
  return (
    <div
      {...reset}
      className={`${className ? className : ''} ${loading ? 'opacity-40' : ''}`}
      style={{
        borderRadius: borderRadius || '8px',
        minWidth: minWidth || '',
        color: color || '',
        background: background || '',
      }}
    >
      <button
        onClick={onClick}
        disabled={disabled}
        className={`flex items-center justify-center  w-full h-full ${
          disabled ? 'cursor-not-allowed' : ''
        } ${btnClassName ? btnClassName : ''}`}
      >
        {props.children}
      </button>
    </div>
  );
}

export function NewGradientButton(props: {
  text: string | JSX.Element;
  onClick?: any;
  className?: string;
  disabled?: boolean;
  grayDisable?: boolean;
  disableForUI?: boolean;
  width?: string;
  beatStyling?: boolean;
  opacity?: boolean;
  padding?: string;
  gradient?: string;
  style?: any;
}) {
  const {
    text,
    onClick,
    className,
    disabled,
    grayDisable,
    disableForUI,
    width,
    beatStyling,
    padding,
    gradient,
    style,
  } = props;

  const [beating, setBeating] = useState<boolean>(false);

  const isMobileLayout = useClientMobile();

  return (
    <button
      className={`  ${
        grayDisable ? 'opacity-30' : gradient || 'bg-veGradient'
      } ${width} ${className}  ${
        disabled || beating
          ? 'opacity-30 cursor-not-allowed'
          : 'opacity-80 hover:opacity-100'
      } ${padding ? padding : 'px-5 py-3'} rounded-lg text-center   `}
      onClick={(event) => {
        if (beatStyling) {
          setBeating(true);
        }

        onClick && onClick(event);
      }}
      disabled={disableForUI ? false : disabled || grayDisable}
      style={{
        backgroundColor: grayDisable
          ? isMobileLayout
            ? '#1D2932'
            : '#445867'
          : '',
        ...style,
      }}
    >
      <span className="flex items-center justify-center">
        {beating ? <BeatLoading /> : text}
      </span>
    </button>
  );
}

export function GreenConnectToNearBtn(props: any) {
  const [buttonLoading, setButtonLoading] = useState<boolean>(false);
  const { className } = props;

  const [showWalletSelector, setShowWalletSelector] = useState(false);
  const { modal } = useWalletSelector();

  return (
    <>
      <div
        className={`flex items-center cursor-pointer justify-center rounded-full py-1 text-sm text-black bg-darkGreenColor hover:bg-lightGreenColor ${className} ${
          buttonLoading ? 'opacity-40' : ''
        }`}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          // setButtonLoading(true);
          modal.show();
        }}
      >
        <span className="mr-2">
          <UnLoginIcon width="15" height="13" color="#000" />
        </span>
        <button>
          <ButtonTextWrapper
            loading={buttonLoading}
            Text={() => (
              <FormattedMessage
                id="connect_to_wallet"
                defaultMessage="Connect Wallet"
              />
            )}
          />
        </button>
      </div>
      <WalletSelectorModal
        isOpen={showWalletSelector}
        onRequestClose={() => {
          window.location.reload();
          setShowWalletSelector(false);
        }}
        setShowWalletSelector={setShowWalletSelector}
      />
    </>
  );
}

export function BlacklightConnectToNearBtn(props: any) {
  const [buttonLoading, setButtonLoading] = useState<boolean>(false);
  const { className } = props;

  const [showWalletSelector, setShowWalletSelector] = useState(false);
  const { modal } = useWalletSelector();

  return (
    <>
      <div
        className={`flex items-center cursor-pointer justify-center rounded-full py-1 text-sm text-white bg-black bg-opacity-30 border border-white border-opacity-30 ${className} ${
          buttonLoading ? 'opacity-40' : ''
        }`}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          // setButtonLoading(true);
          modal.show();
        }}
      >
        <span className="mr-2">
          <UnLoginIcon width="15" height="13" color="#fff" />
        </span>
        <button>
          <ButtonTextWrapper
            loading={buttonLoading}
            Text={() => (
              <FormattedMessage
                id="connect_wallet"
                defaultMessage="Connect Wallet"
              />
            )}
          />
        </button>
      </div>
      <WalletSelectorModal
        isOpen={showWalletSelector}
        onRequestClose={() => {
          window.location.reload();
          setShowWalletSelector(false);
        }}
        setShowWalletSelector={setShowWalletSelector}
      />
    </>
  );
}

export const BuyNearButton = () => {
  const [hover, setHover] = useState<boolean>(false);

  const wallet = getCurrentWallet().wallet;

  const isMobile = useClientMobile();
  return (
    <button
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        openTransak(wallet.getAccountId() || '');
      }}
      className="relative z-50"
      onMouseEnter={() => {
        setHover(true);
      }}
      onMouseLeave={() => {
        setHover(false);
      }}
    >
      {isMobile ? (
        <BuyNearIcon />
      ) : hover ? (
        <BuyNearHoverIcon />
      ) : (
        <BuyNearIcon />
      )}
    </button>
  );
};

export function ConnectToNearBtnSwap() {
  const [hover, setHover] = useState(false);
  const [buttonLoading, setButtonLoading] = useState<boolean>(false);

  const [showWalletSelector, setShowWalletSelector] = useState(false);

  const [showWalletRisk, setShowWalletRisk] = useState<boolean>(false);

  const { modal } = useWalletSelector();

  const handleModalOpen = () => {
    const isAcknowledgeWalletRisk = localStorage.getItem(
      CONST_ACKNOWLEDGE_WALLET_RISK
    );
    if (!isAcknowledgeWalletRisk) {
      setShowWalletRisk(true);
    } else {
      modal.show();
    }
  };

  const handleAcknowledgeClick = (status) => {
    if (status === true) {
      setShowWalletRisk(false);
      localStorage.setItem(CONST_ACKNOWLEDGE_WALLET_RISK, '1');
      modal.show();
    }
  };

  return (
    <>
      <div
        className={`flex items-center gotham_bold cursor-pointer justify-center rounded-full py-3 text-base font-semibold bg-buttonGradientBg text-black ${
          hover ? 'opacity-90' : ''
        }`}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          // setButtonLoading(true);
          handleModalOpen();
        }}
        onMouseEnter={() => {
          setHover(true);
        }}
        onMouseLeave={() => {
          setHover(false);
        }}
      >
        {!buttonLoading && (
          <div className="mr-3.5 transform scale-75">
            <UnLoginIcon color="#04121A" />
          </div>
        )}

        <button disabled={buttonLoading}>
          <ButtonTextWrapper
            loading={buttonLoading}
            Text={() => (
              <FormattedMessage
                id="connect_wallet"
                defaultMessage="Connect Wallet"
              />
            )}
          />
        </button>
      </div>

      <WalletRiskCheckBoxModal
        isOpen={showWalletRisk}
        setCheckedStatus={handleAcknowledgeClick}
        onClose={() => setShowWalletRisk(false)}
      />

      <WalletSelectorModal
        isOpen={showWalletSelector}
        onRequestClose={() => {
          window.location.reload();
          setShowWalletSelector(false);
        }}
        setShowWalletSelector={setShowWalletSelector}
      />
    </>
  );
}
